import Container, {
  defaultProps as ContainerDefaultProps,
  propTypes as ContainerPropTypes,
  ShapeMaxWidth as ContainerShapeMaxWidth,
} from './Container';

export default Container;

export { ContainerDefaultProps, ContainerPropTypes, ContainerShapeMaxWidth };
